import styled from 'styled-components'

export const ContainerChart = styled.div`
  width: calc(100% / 3);
`
